export const INTERNAL_UI_CONFIG_OVERRIDE = 'tw-internal-ui-config-override';
